import { HttpContextToken } from '@angular/common/http';

/**
 * When set to true on an HTTP request context, the global NotFoundInterceptor
 * will NOT handle the 404 -- the calling page is responsible for its own handling.
 *
 * Usage:
 *   const context = new HttpContext().set(HANDLE_404_LOCALLY, true);
 *   this.httpClient.get(url, { context });
 */
export const HANDLE_404_LOCALLY = new HttpContextToken<boolean>(() => false);
